// @flow

import Organization from '../organization/organization.model.js';

export default class Transaction {
  static getListLink(pilotId: string, orgUnique: string): string {
    return `${window.serverData._uri}${
      Organization.orgAccess ? `/org/${orgUnique}/transactions/users/${pilotId}/` : '/transactions/'
    }`;
  }

  static getInvoiceLink(transactionId: string, orgUnique: string): string {
    return `${window.serverData._uri}${
      Organization.orgAccess
        ? `/org/${orgUnique}/transactions/${transactionId}/`
        : `/transactions/${transactionId}/`
    }`;
  }
}
